import React from "react"
import classnames from "classnames"
import * as styles from "./text.module.css"

export const mkText =
  ({
    color,
    className,
    lineHeight,
  }: {
    color?: string
    className?: string
    lineHeight?: number
  }) =>
  ({ children }: { children: React.ReactNode }) => {
    return (
      <span
        className={classnames(styles.text, className)}
        style={{
          ["--line-height" as any]: lineHeight,
          color,
          ["--color" as any]: color,
        }}
      >
        {children}
      </span>
    )
  }
